/**
 * CEX integration saga
 */
import { takeLatest, put, call, select, delay } from 'redux-saga/effects';
import {
  CHECK_CEX,
  CHECK_CEX_DONE,
  REVOKE_CEX_KEYS,
  actionCheckCEX,
  actionCheckCEXDone,
  actionCheckCEXFail,
  actionSetCurrentExchange,
} from '../actions/cex_trading';
import { authTokenSelector } from '../selectors/auth';
import { LOG_OUT, SET_AUTH } from '../actions/auth';
import { CexAPI, subscription } from '../store/createStore';
import { ICEXCheckResponse, ICexApiResponse, enums } from '@kattana-io/common';
import { actionCreateNotification } from '../actions/notifications';
import { SWITCH } from '../actions/current';
import { IStore } from '../reducers';

const backendCleanupDelay = 1000;

function* onCheckCEX(): any {
  try {
    const token = yield select(authTokenSelector);
    const res: ICexApiResponse<ICEXCheckResponse> = yield call(
      CexAPI.checkEnabledExchanges,
      token
    );

    if (res.success && res.data) {
      yield put(actionCheckCEXDone(res.data));

      // Subscribe to cex events
      const wallet = yield select((state: IStore) => state.auth.wallet);
      subscription.subscribeToCEXBalances(wallet);
      subscription.subscribeToCEXOrders(wallet);
    } else {
      yield put(actionCheckCEXFail());
    }
  } catch (err) {
    yield put(actionCheckCEXFail());
    console.error(err);
  }
}

function* onRevokeCEX(action: any): any {
  try {
    const token = yield select(authTokenSelector);
    yield call(CexAPI.revokeAPIKey, token, action.payload);
    yield delay(backendCleanupDelay);
    yield put(actionCheckCEX()); // refetch status
    yield put(
      actionCreateNotification({
        kind: 'info',
        message: `Successfully revoked ${action.payload} key`,
      })
    );
  } catch (err) {
    yield put(
      actionCreateNotification({
        kind: 'error',
        message: `Failed to revoke ${action.payload} key`,
      })
    );
    yield put(actionCheckCEXFail());
    console.error(err);
  }
}

function* onSwitchTicker(action: any): any {
  const { exchange, kind } = action.payload;
  if (kind === enums.ETickerKind.CEX) {
    yield put(actionSetCurrentExchange(exchange));
  }
}

function* onAuth(): any {
  try {
    yield put(actionCheckCEX());
  } catch (error) {
    console.error(error);
  }
}

function* onLogOut(): any {
  try {
    yield put(actionCheckCEXFail());
    subscription.unsubscribeFromCEXBalances();
    subscription.unsubscribeFromCEXOrders();
  } catch (error) {
    console.error(error);
  }
}

function* onSubscribe(): any {}

export default function* cexSaga() {
  yield takeLatest(SET_AUTH, onAuth);
  yield takeLatest(LOG_OUT, onLogOut);
  yield takeLatest(CHECK_CEX, onCheckCEX);
  yield takeLatest(REVOKE_CEX_KEYS, onRevokeCEX);
  yield takeLatest(CHECK_CEX_DONE, onSubscribe);
  yield takeLatest(SWITCH, onSwitchTicker);
}
